// Фаза 2: короткие префиксы для типов помещений (по плану: Парк-{flat}, Клад-{flat}, etc.)
// BASEMENT удалён бэкендом (OSI.Core dev 34d6a1f); ARENDATOR — не отображается через makeFlat
// (арендаторы рендерятся отдельно как "Аренда(name)").
import i18next from 'i18next';

const areaPrefixes: Record<string, { ru: string; kk: string }> = {
  PARKING: { ru: 'Парк', kk: 'Тұрақ' },
  STORAGE: { ru: 'Клад', kk: 'Қойма' },
  NON_RESIDENTIAL: { ru: 'Неж', kk: 'Тұрғ.емес' }
};

/**
 * Форматирование номера помещения с префиксом типа.
 * RESIDENTIAL → просто flat, остальные → "Парк-{flat}" (ru) / "Тұрақ-{flat}" (kk).
 * Локаль берётся автоматически из i18next.language ('ru' или 'kk').
 */
export const makeFlat = (e: any) => {
  if (!e?.areaTypeCode || e.areaTypeCode === 'RESIDENTIAL') return e?.flat;
  const prefix = areaPrefixes[e.areaTypeCode];
  if (!prefix) return e.flat;
  const lang = i18next.language === 'kk' ? 'kk' : 'ru';
  return `${prefix[lang]}-${e.flat}`;
};
